module.exports = __webpack_public_path__ + "img/banner_left.d3d1e233.png";